(() => {
  const FRAME_OPTION_NAMES = ['çerçeve', 'frame'];
  const SIZE_OPTION_NAMES = ['boyut', 'size', 'product size'];
  const PLACE_OPTION_NAMES = [
    'baskı yerleşimi',
    'baski yerlesimi',
    'baskı yerlesimi',
    'baskı yerleşimi',
    'placement',
    'print placement',
  ];

  /*
    Baskı yerleşimi bir varyant değil, tamamen tarayıcı tarafında bir çizim
    kipidir: müşteri Tam Oturt ya da Ortala seçer, önizleme yeniden hesaplanır.
    Fiyat, varyant ve ürün verisi değişmez.

    Neden sabit liste: seçenekler eskiden varyant seçeneklerinden okunuyordu
    (uniqueOptionValues + PLACE_OPTION_NAMES). Katalogdaki 3000 ürünün
    hiçbirinde "Baskı yerleşimi" diye bir varyant seçeneği yok, bu yüzden liste
    her ürün için boş dönüyor ve panelde "Baskı yerleşimi" başlığı altı boş
    kalıyordu. Kip varyanta bağlı olmadığı için seçenekler de burada sabit
    duruyor; medya alt metinlerine ("Çerçevesiz|Tam Oturt") de bakılmıyor,
    çünkü o kodlama artık güvenilir değil.

    Sıra önemli: ilk öge öntanımlı kip. Tam Oturt başta, böylece müşteri
    Ortala'yı kendisi seçmedikçe çizim bugünküyle birebir aynı kalır.

    PLACE_OPTION_NAMES korunuyor: bir ürün ileride gerçekten bu seçeneği
    taşırsa varyant eşlemesi ve görsel seçimi çalışmaya devam etsin.
  */
  const PLACEMENT_MODES = ['Tam Oturt', 'Ortala'];

  const isOrtala = (placement) => /ortala/i.test(String(placement || ''));
  const isTamOturt = (placement) => /tam\s*oturt/i.test(String(placement || ''));

  const isFrameless = (frame) => /çerçevesiz|cercevesiz|frameless|unframed/i.test(String(frame || ''));

  /*
    Paspas kuralı artık paspas-kurali.js'te tek yerde duruyor; ürün sayfası da
    aynı işlevi çağırıyor. Çağrı çizim anında yapılır, o sırada betik yüklüdür.
  */
  const matEserKutusu = (kagitG, kagitY) => window.AlaPaspas.eserKutusu(kagitG, kagitY);

  /*
    Duvardaki poster, sahne genişliğinin küçük bir bölümünü kaplar: 280 cm'lik
    duvarda 50x70 bir eser 1440 px ekranda ~200 px'tir. Medya kütüphanesindeki
    asıl dosya ise 4096 px ve 3-4 MB olabiliyor; işlenmemiş adres kullanılınca
    poster görünene kadar saniyeler geçiyordu. Shopify CDN'den ölçülü bir
    kopya istenir: ekranda retina için de, paylaşım tuvali için de yeterli.
  */
  const ART_RENDER_WIDTH = 1200;

  const sizedArtUrl = (url, width) => {
    if (!url) return url;
    /* Yalnızca Shopify CDN adresleri işlenebilir */
    if (!/\/cdn\/|cdn\.shopify\.com/.test(url)) return url;
    /* Liquid'den gelen adreslerde ölçü zaten var, ikinci kez eklenmez */
    if (/[?&]width=/.test(url)) return url;
    return `${url}${url.includes('?') ? '&' : '?'}width=${width || ART_RENDER_WIDTH}`;
  };

  const preferTamOturt = (placements) => {
    const list = placements || [];
    if (list.includes('Tam Oturt')) return 'Tam Oturt';
    const hit = list.find((p) => isTamOturt(p));
    return hit || list[0] || 'Tam Oturt';
  };

  const preferOrtala = (placements) => {
    const list = placements || [];
    if (list.includes('Ortala')) return 'Ortala';
    const hit = list.find((p) => isOrtala(p));
    return hit || list[0] || 'Ortala';
  };

  const preferBlackFrame = (frames) => {
    const list = frames || [];
    if (list.includes('Siyah')) return 'Siyah';
    const hit = list.find((f) => /siyah|black/i.test(String(f || '')));
    if (hit) return hit;
    if (list.includes('Çerçevesiz')) return 'Çerçevesiz';
    return list[0] || 'Siyah';
  };

  const FRAME_COLORS = {
    Siyah: '#1a1a1a',
    Beyaz: '#f3f3f3',
    Kahverengi: '#6b4a2e',
    'Meşe': '#c69f68',
    'Koyu Meşe': '#8a5c34',
    'Yeşil': '#37503f',
    Mavi: '#33517c',
    'Açık Mavi': '#a9c4d8',
    'Kırmızı': '#a63127',
    'Sarı': '#ddb23e',
    Pembe: '#e2b5c0',
  };

  /*
    Sonuç akışı Shopify'ın Section Rendering API'siyle beslenir. Kartlar ve
    filtre seçenekleri aynı istekten gelir; böylece filtre tüm katalogda
    çalışır, yalnızca ekrana yüklenmiş kartlarda değil.
  */
  const RESULTS_SECTION = 'awd-results';
  const COUNT_SECTION = 'awd-count';
  const ARTISTS_SECTION = 'awd-artists';
  const ARTISTS_CACHE_KEY = 'awd-artists-v1';
  /* Sanatçı listesinde her kaydırmada eklenen isim sayısı */
  const ARTIST_PAGE = 60;

  /*
    Sanatçı aramasında aksan ve büyük harf farkı aranmaz: "edouard" yazan
    ziyaretçi "Édouard Manet"yi, "bocklin" yazan "Böcklin"i bulur.
    Sadeleştirme ala-text-fold.js içindeki ortak işlevdir; galeri araması da
    aynısını kullanır, böylece iki sayfa aynı ismi aynı şekilde eşler.
  */
  const fold = (str) =>
    window.AlaText && window.AlaText.fold
      ? window.AlaText.fold(str)
      : String(str || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');

  /* "Koleksiyon türü" seçenekleri kapsam koleksiyonunu değiştirir. */
  const SCOPE_OPTIONS = [
    { value: '', label: 'Tümü' },
    { value: 'alalart-seckisi', label: 'Alalart seçkisi' },
    { value: 'yeni-gelenler', label: 'Yeni gelenler' },
    { value: 'ozel-boyutlu-baskilar', label: 'Özel boyutlu baskılar' },
    { value: 'duvar-setleri', label: 'Duvar setleri' },
    { value: 'cok-satanlar', label: 'Çok satanlar' },
  ];

  /* Altta yinelenen "Koleksiyon türü" facet'ini gizle (üst SCOPE bloğu yeter). */
  const SKIP_KOLEKSIYON_TURU_RE = /koleksiyon\s*t[uü]r[uü]/i;

  /*
    Filtre panelindeki bölüm sırası ve Türkçe başlıklar. Listede olmayan bir
    filtre Search & Discovery'de açıldığında kendi etiketiyle sona eklenir;
    böylece panel veri anlık görüntüsüne değil şemaya bağlı kalır.
    Sanatçı Shopify facet'i bilinçli dışarıda: özel sanatçı seçici kullanılır.
  */
  const FACET_ORDER = [
    'filter.p.m.filtre.yon',
    'filter.p.m.filtre.renk',
    'filter.p.m.filtre.tema',
    'filter.p.m.custom.mekan',
  ];

  const FACET_LABELS = {
    'filter.p.m.filtre.yon': 'Yön',
    'filter.p.m.filtre.renk': 'Renk',
    'filter.p.m.filtre.tema': 'Tema',
    'filter.p.m.custom.mekan': 'Mekân',
  };

  /* Yön filtresinde panoramik seçenekleri gizlenir; özel boyut koleksiyonundan ulaşılır. */
  const HIDDEN_YON_RE = /panoramik/i;
  const SKIP_FACET_RE = /filtre\.sanatci$/i;

  const orientationOf = (aspect) => {
    const a = Number(aspect || 0);
    if (!(a > 0)) return null;
    if (a >= 1.6) return 'panoramik';
    if (a > 1) return 'yatay';
    return 'dikey';
  };

  /**
   * Exact TPC fill (theposterclub art-wall-designer.js):
   *   PRINT_SIZE_SCALE={"30x40":1.05,"40x50":1.1}
   */
  const TPC_PRINT_SIZE_SCALE = {
    '30x40': 1.05,
    '40x50': 1.1,
  };

  const sizeKeyCm = (label) => {
    const parsed = parseSizeCm(label);
    if (!parsed) return null;
    const a = Math.round(Math.min(parsed.w, parsed.h));
    const b = Math.round(Math.max(parsed.w, parsed.h));
    return `${a}x${b}`;
  };

  const TPC_TUCK_SCALE = 0.985;
  const TPC_FRAME_LIP_CM = 1.5;

  const printFillScale = (sizeLabel) => {
    const key = sizeKeyCm(sizeLabel);
    return (key && TPC_PRINT_SIZE_SCALE[key]) || 1;
  };

  const normalizeTags = (product) =>
    (product.tags || []).map((t) => String(t || '').toLowerCase().trim());

  const placementFromTags = (product, placements) => {
    const tags = normalizeTags(product);
    const has = (re) => tags.some((t) => re.test(t));
    if (has(/awd[-_]?ortala|exhibition|sergi|edge[-_]?text|kenar[-_]?yazi|typography/)) {
      if (placements.includes('Ortala')) return 'Ortala';
    }
    if (has(/awd[-_]?tam[-_]?oturt|full[-_]?bleed|tam[-_]?oturt/)) {
      if (placements.includes('Tam Oturt')) return 'Tam Oturt';
    }
    return null;
  };

  const loadImage = (url) =>
    new Promise((resolve) => {
      if (!url) return resolve(null);
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img);
      img.onerror = () => resolve(null);
      img.src = url;
    });

  /*
    Duvara eklenen eserin başlangıç boyutu: ürünün kendi boyut merdiveninin
    ortası. 30x40 | 50x70 | 70x100 için 50x70, kare merdivende ortadaki kare,
    2:1 panoramikte ortadaki panoramik.

    Merdiven üründen okunur, temada boyut listesi tutulmaz: merdivenler hâlâ
    düzenleniyor ve sabit bir tablo saatler içinde eskir. Basamak sayısı da
    varsayılmaz; kaç basamak varsa alanına göre sıralanır ve ortası alınır.
    Çift basamakta ortanın üstü seçilir, çünkü tercih küçükten yana değil.

    Neden eserin en/boy oranına bakılmıyor: merdiven zaten eserin biçimine
    göre kurulmuş, dolayısıyla basamakların oranları birbirinin aynısı
    (kare 1/1/1, panoramik 2/2/2). Oran karşılaştırması bu durumda hiçbir
    basamağı ayırt edemiyor, eşitlik ilk sıradakine düşüyor ve merdivenin en
    küçüğü seçiliyordu. Standart merdivenlerde oranlar da birbirine çok yakın
    (0,75 / 0,714 / 0,700) ve eserin gerçek oranı bunların hepsinden uzak
    olduğu için orada da en küçük kazanıyordu; 50x70 gelmesinin tek nedeni
    eskiden bu ölçünün elle öne alınmasıydı. Kısacası oran mantığı katkı
    sağlamadığı için kaldırıldı, ölü kod bırakılmadı.
  */
  const pickLadderMiddleSize = (sizes) => {
    if (!sizes || !sizes.length) return null;
    const ranked = sizes
      .map((label) => ({ label, parsed: parseSizeCm(label) }))
      .filter((entry) => entry.parsed)
      /* Alan, basamağı büyüklüğüne göre sıralamanın yön bağımsız yoludur */
      .sort((a, b) => a.parsed.w * a.parsed.h - b.parsed.w * b.parsed.h);
    /* Ölçüsü okunamayan etiketler varsa listenin kendi sırası kullanılır */
    if (!ranked.length) return sizes[Math.floor(sizes.length / 2)];
    return ranked[Math.floor(ranked.length / 2)].label;
  };

  /**
   * Başlangıç boyutu merdivenin ortası, yerleşim Ortala (etiket Tam Oturt'a
   * zorlayabilir). Varsayılan çerçeve Siyah (addProduct içinde).
   */
  const resolveSmartDefaults = (product, sizes, placements, fallbackSize) => {
    const taggedPlacement = placementFromTags(product, placements);

    return {
      size: pickLadderMiddleSize(sizes) || fallbackSize,
      placement: taggedPlacement || preferOrtala(placements),
      _debug: { taggedPlacement },
    };
  };

  /**
   * TPC architecture: wall shows frameless print; frame is a CSS overlay.
   * Most products only upload Çerçevesiz|Tam Oturt — Ortala is synthesized
   * (paspas paper + art at MAT_SCALE) when a dedicated Ortala image is missing.
   */
  const resolveWallImageRaw = (product, selected) => {
    const images = product.images || {};
    const placement = selected?.placement || 'Tam Oturt';
    const frame = selected?.frame || 'Çerçevesiz';
    const wantsOrtala = isOrtala(placement);

    const pick = (keys) => {
      for (const key of keys) {
        if (images[key]) return images[key];
      }
      return null;
    };

    const findArtUrl = () =>
      pick(['Çerçevesiz|Tam Oturt', 'Cercevesiz|Tam Oturt', 'Çerçevesiz|Ortala', 'Cercevesiz|Ortala']) ||
      pick([`Çerçevesiz|${placement}`, `Cercevesiz|${placement}`]) ||
      Object.keys(images)
        .filter((k) => /çerçevesiz|cercevesiz/i.test(k))
        .map((k) => images[k])[0] ||
      product.featuredImage ||
      null;

    /*
      Catalog only uploads full-bleed Tam Oturt art. Variant image maps often
      also expose Çerçevesiz|Ortala pointing at that same URL, which previously
      skipped mat synthesis. Ortala always synthesizes paspas paper + MAT_SCALE.
    */
    if (wantsOrtala) {
      const artUrl = findArtUrl();
      if (artUrl) return { url: artUrl, baked: false, synthMat: true };
    }

    let url = pick([`Çerçevesiz|${placement}`, `Cercevesiz|${placement}`]);
    if (url) return { url, baked: false, synthMat: false };

        const framedKeys = [
      `${frame}|${placement}`,
      `${frame.toLowerCase()}|${placement}`,
    ];
    url = pick(framedKeys);
    if (url) return { url, baked: true, synthMat: false };

    const loose = Object.keys(images).find((k) => {
      const low = k.toLowerCase();
      if (wantsOrtala) return low.includes('ortala') || low.includes('tam oturt');
      if (isTamOturt(placement)) return low.includes('tam oturt') || low.includes('tam-oturt');
      return false;
    });
    if (loose) {
      const low = loose.toLowerCase();
      const synthMat = wantsOrtala && !low.includes('ortala') && low.includes('tam oturt');
      return { url: images[loose], baked: false, synthMat };
    }

    const frameIdx = optionIndex(product, FRAME_OPTION_NAMES);
    const placeIdx = optionIndex(product, PLACE_OPTION_NAMES);
    const sizeIdx = optionIndex(product, SIZE_OPTION_NAMES);
    const variants = product.variants || [];

    const scoreVariant = (v) => {
      const vFrame = variantOptionValue(v, frameIdx);
      const place = variantOptionValue(v, placeIdx);
      const size = variantOptionValue(v, sizeIdx);
      const img = v.featured_image || v.featuredImage;
      if (!img) return -1;
      /* Prefer matching placement; allow Tam Oturt art when synthesizing Ortala */
      if (place !== placement) {
        if (!(wantsOrtala && isTamOturt(place))) return -1;
      }
      let score = 10;
      if (isFrameless(vFrame)) score += 50;
      else if (vFrame === frame) score += 20;
      if (place === placement) score += 15;
      if (size === selected?.size) score += 5;
      return score;
    };

    let best = null;
    let bestScore = -1;
    variants.forEach((v) => {
      const s = scoreVariant(v);
      if (s > bestScore) {
        bestScore = s;
        best = v;
      }
    });
    if (best) {
      const bestFrame = variantOptionValue(best, frameIdx);
      const bestPlace = variantOptionValue(best, placeIdx);
      return {
        url: best.featured_image || best.featuredImage || null,
        baked: bestFrame === frame && !isFrameless(frame),
        synthMat: wantsOrtala && !isOrtala(bestPlace),
      };
    }
    return {
      url: product.featuredImage || null,
      baked: false,
      synthMat: wantsOrtala,
    };
  };

  /*
    Görsel seçimi değişmez; yalnızca adres duvara uygun ölçüye indirilir.
    baked ve synthMat olduğu gibi geçer, çerçeve ve paspas kuralları aynı.
  */
  const resolveWallImage = (product, selected) => {
    const resolved = resolveWallImageRaw(product, selected);
    return { ...resolved, url: sizedArtUrl(resolved.url) };
  };

  const parseSizeCm = (label) => {
    if (!label) return null;
    const m = String(label)
      .toLowerCase()
      .replace(',', '.')
      .match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
    if (!m) return null;
    return { w: parseFloat(m[1]), h: parseFloat(m[2]) };
  };

  const money = (cents, root) => {
    const format = root.dataset.moneyFormat || '{{amount}}';
    const amount = (Number(cents || 0) / 100).toFixed(2);
    if (format.includes('{{amount_no_decimals_with_comma_separator}}')) {
      const wholeTr = String(Math.round(Number(cents || 0) / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return format.replace('{{amount_no_decimals_with_comma_separator}}', wholeTr);
    }
    if (format.includes('{{amount_with_comma_separator}}')) {
      return format.replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
    }
    if (format.includes('{{amount_no_decimals}}')) {
      return format.replace('{{amount_no_decimals}}', String(Math.round(Number(cents || 0) / 100)));
    }
    return format.replace('{{amount}}', amount).replace('{{amount_with_currency}}', `${amount} ${root.dataset.currency || ''}`);
  };

  const optionIndex = (product, names) => {
    const opts = product.options || [];
    for (let i = 0; i < opts.length; i += 1) {
      const name = String(opts[i].name || opts[i] || '').toLowerCase();
      if (names.some((n) => name.includes(n))) return i;
    }
    return -1;
  };

  const variantOptionValue = (variant, index) => {
    if (index < 0) return null;
    if (Array.isArray(variant.options)) return variant.options[index];
    return variant[`option${index + 1}`];
  };

  const findVariant = (product, selected) => {
    const sizeIdx = optionIndex(product, SIZE_OPTION_NAMES);
    const frameIdx = optionIndex(product, FRAME_OPTION_NAMES);
    const placeIdx = optionIndex(product, PLACE_OPTION_NAMES);
    return (product.variants || []).find((v) => {
      const sizeOk = sizeIdx < 0 || variantOptionValue(v, sizeIdx) === selected.size;
      const frameOk = frameIdx < 0 || variantOptionValue(v, frameIdx) === selected.frame;
      const placeOk = placeIdx < 0 || variantOptionValue(v, placeIdx) === selected.placement;
      return sizeOk && frameOk && placeOk;
    });
  };

  const uniqueOptionValues = (product, names) => {
    const idx = optionIndex(product, names);
    if (idx < 0) return [];
    const values = [];
    (product.variants || []).forEach((v) => {
      const val = variantOptionValue(v, idx);
      if (val && !values.includes(val)) values.push(val);
    });
    return values;
  };

  /* Sanatçı adı: "Egon Schiele — Galerie Arnot" başlığından; yoksa vendor */
  const artistOf = (product) => {
    const title = String(product.title || '');
    const m = title.split(/\s+[—–-]{1,2}\s+/);
    if (m.length > 1 && m[0].trim()) return m[0].trim();
    return product.vendor || '';
  };

  /* Kartlarda yalnızca eser adı: "Sanatçı - Eser (yıl)" → "Eser (yıl)" */
  const artworkTitleOf = (product) => {
    if (product && product.artwork) return String(product.artwork);
    const title = String((product && product.title) || '');
    const m = title.split(/\s+[—–-]{1,2}\s+/);
    if (m.length > 1) return m.slice(1).join(' - ').trim() || title;
    return title;
  };

  const minVariantPrice = (product) => {
    let min = Infinity;
    (product.variants || []).forEach((v) => {
      const p = Number(v.price || 0);
      if (p > 0 && p < min) min = p;
    });
    return Number.isFinite(min) ? min : 0;
  };

  const escapeHtml = (s) =>
    String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const CARD_HOVER = '<span class="awd__card-hover"><span class="awd__card-hover-plus">+</span> Duvara ekle</span>';

  const HEART_PATH =
    'M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z';
  const HEART_SVG =
    '<svg class="card__wishlist-icon card__wishlist-icon--outline" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' +
    HEART_PATH +
    '"/></svg>' +
    '<svg class="card__wishlist-icon card__wishlist-icon--filled" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' +
    HEART_PATH +
    '"/></svg>';

  const cardOrientClass = (aspect) => {
    const o = orientationOf(aspect);
    return o ? `awd__card-add--${o}` : 'awd__card-add--dikey';
  };

  /*
    AJAX ürün adaptörü: /products/{handle}.js → tasarımcının ürün şemasına.
    Kartlar yalnızca listeleme alanlarını taşıdığı için varyantlar, seçenekler
    ve çerçeve görsel haritası ürün duvara eklenirken buradan gelir.
    stub, karttan okunan hafif veridir; eksik alanlarda yedek olarak kullanılır.
  */
  const ajaxProductCache = {};
  const ajaxProductPending = {};
  const fetchAjaxProduct = async (handle, stub) => {
    if (!handle) return null;
    if (ajaxProductCache[handle]) return ajaxProductCache[handle];
    if (ajaxProductPending[handle]) return ajaxProductPending[handle];
    const run = (async () => {
      try {
        const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
        if (!res.ok) return null;
        const p = await res.json();
        const images = {};
        (p.media || []).forEach((m) => {
          const src = (m.preview_image && m.preview_image.src) || m.src || null;
          if (m.alt && src && !images[m.alt]) images[m.alt] = src;
        });
        /*
          Medya alt metinleri boş kalan ürünlerde Çerçeve|Yerleşim anahtarları
          varyantlardan türetilir. Liquid kartında da aynı tamamlama vardı.
        */
        (p.variants || []).forEach((v) => {
          const src = v.featured_image && v.featured_image.src;
          if (!src || !v.option2 || !v.option3) return;
          const key = `${v.option2}|${v.option3}`;
          if (!images[key]) images[key] = src;
        });
        /*
          En/boy oranı akıllı boyut seçiminin tek girdisidir, bu yüzden duvarda
          kullanılan görselden okunur. Kart verisi varsa (Liquid'de aynı
          görselden hesaplanır) o kullanılır; favoriler gibi kartı olmayan
          yolda "Çerçevesiz|Tam Oturt" medyası aranır, o da yoksa ilk medya.
        */
        let aspect = Number((stub && stub.aspect) || 0);
        const mediaList = p.media || [];
        const artMedia =
          mediaList.find((m) => /çerçevesiz\|tam oturt|cercevesiz\|tam oturt/i.test(String(m.alt || ''))) ||
          mediaList.find((m) => /tam oturt/i.test(String(m.alt || ''))) ||
          mediaList[0];
        if (!(aspect > 0) && artMedia && artMedia.preview_image && artMedia.preview_image.height) {
          aspect = artMedia.preview_image.width / artMedia.preview_image.height;
        }
        const product = {
          id: p.id,
          handle: p.handle,
          title: p.title,
          artwork: (stub && stub.artwork) || artworkTitleOf({ title: p.title }),
          vendor: p.vendor || (stub && stub.vendor) || '',
          url: p.url || `/products/${p.handle}`,
          featuredImage:
            images['Çerçevesiz|Tam Oturt'] ||
            images['Cercevesiz|Tam Oturt'] ||
            (stub && stub.featuredImage) ||
            p.featured_image ||
            null,
          tags: p.tags || [],
          aspect,
          collections: [],
          images,
          options: p.options || [],
          variants: (p.variants || []).map((v) => ({
            id: v.id,
            title: v.title,
            available: v.available,
            price: v.price,
            compare_at_price: v.compare_at_price,
            options: [v.option1, v.option2, v.option3].filter((x) => x != null),
            option1: v.option1,
            option2: v.option2,
            option3: v.option3,
            featured_image: v.featured_image ? v.featured_image.src : null,
          })),
        };
        ajaxProductCache[handle] = product;
        return product;
      } catch (e) {
        return null;
      } finally {
        delete ajaxProductPending[handle];
      }
    })();
    ajaxProductPending[handle] = run;
    return run;
  };

  const encodeState = (obj) => btoa(unescape(encodeURIComponent(JSON.stringify(obj))));
  const decodeState = (str) => {
    try {
      return JSON.parse(decodeURIComponent(escape(atob(str))));
    } catch (e) {
      return null;
    }
  };

  class ArtWallDesigner extends HTMLElement {
    connectedCallback() {
      this._isDesktop = window.matchMedia('(min-width: 900px)').matches;
      if (!this._isDesktop) return;
      this.wall = [];
      this.selectedId = null;
      this.drag = null;
      this.wallWidthCm = Number(this.dataset.wallWidthCm || 280);
      this.defaultSize = this.dataset.defaultSize || '50x70';
      this._cartSynced = {};
      this._favProducts = {};

      this.stage = this.querySelector('[data-awd-stage]');
      this.configureEl = this.querySelector('[data-awd-configure]');
      this.configureBody = this.querySelector('[data-awd-configure-body]');
      this.grid = this.querySelector('[data-awd-grid]');
      this.favGrid = this.querySelector('[data-awd-fav-grid]');
      this.subtotalEl = this.querySelector('[data-awd-subtotal]');
      this.shopBtn = this.querySelector('[data-awd-shop]');

      this.scope = this.dataset.scope || 'all';
      this.baseScope = this.scope;
      this.perPage = Number(this.dataset.perPage || 48);
      this.totalKnown = Number(this.dataset.total || 0);

      /* Aktif filtreler: Shopify filtre parametresi -> seçilen değerler */
      this.activeFilters = new Map();
      this.sortScope = '';
      this.facets = [];

      /*
        Sanatçı seçimi Shopify facet'i değil, sanatçı koleksiyonları üzerinden
        çalışır. Böylece 100 değerlik facet sınırı yoktur ve listedeki tüm
        sanatçılara ulaşılır.
      */
      this.artists = [];
      this.artistByHandle = {};
      this.artistQuery = '';
      this.selectedArtists = new Set();

      this.initCatalog();
      this.initStream();
      this.bindTabs();
      this.bindAdd();
      this.bindFooter();
      this.bindStagePointer();
      this.bindFilter();
      this.bindShare();
      this.bindShopDrawer();
      this.bindWishlist();
      this.renderBgChoices();
      this.updateTotals();
      this.restoreFromUrl();
    }

    /* ---------- catalog / filters ---------- */

    /*
      Kartlar hafif veri taşır. Tam ürün (varyantlar, seçenekler, çerçeve
      görselleri) yalnızca gerektiğinde /products/{handle}.js ile gelir.
    */
    stubFromCard(card) {
      if (!card || !card.dataset.awdHandle) return null;
      const aspect = Number(card.dataset.awdAspect || 0);
      return {
        id: Number(card.dataset.awdId || 0),
        handle: card.dataset.awdHandle,
        title: card.dataset.awdTitle || '',
        artwork: card.dataset.awdArtwork || '',
        vendor: card.dataset.awdVendor || '',
        url: card.dataset.awdUrl || `/products/${card.dataset.awdHandle}`,
        featuredImage: card.dataset.awdArt || null,
        aspect,
        price: Number(card.dataset.awdPrice || 0),
      };
    }

    initCatalog() {
      this.catalog = [];
      this.catalogByHandle = {};
      this.stubByHandle = {};
      this.seenHandles = new Set();
      this.registerCards(this.querySelectorAll('[data-awd-product-card]'));
    }

    registerCards(cards) {
      cards.forEach((card) => {
        const stub = this.stubFromCard(card);
        if (!stub) return;
        this.stubByHandle[stub.handle] = stub;
        this.seenHandles.add(stub.handle);
        this.catalog.push({ card, stub });
      });
    }

    /* Tam ürün: önbellek, sonra kartın hafif verisi yedeğiyle ağ isteği */
    async getProduct(handle) {
      if (!handle) return null;
      if (this.catalogByHandle[handle]) return this.catalogByHandle[handle];
      const product = await fetchAjaxProduct(handle, this.stubByHandle[handle]);
      if (product) this.catalogByHandle[handle] = product;
      return product;
    }

    /* ---------- sunucu taraflı akış ---------- */

    /*
      Sonuç kaynağı bir koleksiyondur. Sanatçı seçilmemişse tek kaynak vardır
      (tüm ürünler ya da sıralama koleksiyonu). Sanatçı seçildiğinde her
      sanatçının koleksiyonu ayrı bir kaynaktır ve sırayla akıtılır; renk,
      tema, mekân ve yön filtreleri her kaynağa aynı şekilde uygulanır.
    */
    scopeUrl(section, scope, page) {
      const params = new URLSearchParams();
      params.set('section_id', section);
      if (page > 1) params.set('page', String(page));
      this.activeFilters.forEach((values, param) => {
        values.forEach((v) => params.append(param, v));
      });
      const root = window.Shopify?.routes?.root || '/';
      return `${root}collections/${encodeURIComponent(scope)}?${params.toString()}`.replace(
        '//collections',
        '/collections'
      );
    }

    buildSources() {
      if (this.selectedArtists.size) {
        return [...this.selectedArtists]
          .map((h) => this.artistByHandle[h] || { h, t: h })
          .sort((a, b) => String(a.t).localeCompare(String(b.t), 'tr'))
          .map((a) => ({ scope: a.h, title: a.t, page: 0, pages: null, count: null }));
      }
      return [
        {
          scope: this.sortScope || this.baseScope || 'all',
          title: '',
          page: 0,
          pages: null,
          count: null,
        },
      ];
    }

    /* Sayaç bölümü kart basmaz; birkaç yüz bayt döner. */
    async fetchCount(scope) {
      const res = await fetch(this.scopeUrl(COUNT_SECTION, scope, 1), {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      });
      if (!res.ok) throw new Error(`awd count ${res.status}`);
      const html = await res.text();
      const raw = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('[data-awd-count]')?.textContent;
      return raw ? JSON.parse(raw) : null;
    }

    /*
      Birden çok sanatçıda toplam sayı önden ölçülür: hem "Sonuçları gör (N)"
      doğru olur hem de o filtrede eseri kalmayan sanatçı hiç istenmez.
    */
    async measureSources(sources, seq) {
      const queue = [...sources];
      const workers = new Array(Math.min(6, queue.length)).fill(0).map(async () => {
        while (queue.length) {
          const src = queue.shift();
          try {
            const meta = await this.fetchCount(src.scope);
            if (meta) {
              src.count = meta.count;
              src.pages = meta.count > 0 ? meta.pages : 0;
            }
          } catch (e) {
            /* ölçülemeyen kaynak normal akışta yine denenir */
          }
          if (seq !== this.loadSeq) return;
        }
      });
      await Promise.all(workers);
    }

    knownTotal() {
      let sum = 0;
      let complete = true;
      (this.sources || []).forEach((s) => {
        if (s.count == null) complete = false;
        else sum += s.count;
      });
      return { sum, complete };
    }

    initStream() {
      this.streamEl = this.querySelector('[data-awd-stream]');
      this.streamMsg = this.querySelector('[data-awd-stream-msg]');
      this.streamRetry = this.querySelector('[data-awd-stream-retry]');
      this.sentinel = this.querySelector('[data-awd-sentinel]');
      this.panelEl = this.querySelector('[data-awd-panel="products"]');

      /*
        Sunucunun bastığı ilk parça birinci sayfadır; akış ikinci sayfadan
        devam eder. Toplam sayı sunucudan gelene kadar tema ayarındaki değer
        gösterilir.
      */
      this.sources = this.buildSources();
      this.sources[0].page = 1;
      this.sources[0].count = this.totalKnown || null;
      this.sourceIndex = 0;
      this.loading = false;
      this.loadSeq = 0;

      /* Hata sonrası yeniden deneme, hangi işlemin başarısız olduğunu izler */
      this._retry = () => this.loadNextPage();
      this.streamRetry?.addEventListener('click', () => {
        this.setStreamState('idle');
        this._retry();
      });

      /*
        Kaydırma dedektörü panelin kendi kaydırma kabında çalışır ve son
        kartlardan epey önce tetiklenir; ziyaretçi bekleme görmez.
      */
      if ('IntersectionObserver' in window && this.sentinel && this.panelEl) {
        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((e) => e.isIntersecting)) this.loadNextPage();
          },
          { root: this.panelEl, rootMargin: '900px 0px' }
        );
        this.observer.observe(this.sentinel);
      } else if (this.panelEl) {
        this.panelEl.addEventListener('scroll', () => {
          const nearEnd =
            this.panelEl.scrollTop + this.panelEl.clientHeight >= this.panelEl.scrollHeight - 900;
          if (nearEnd) this.loadNextPage();
        });
      }

      this.updateResultLabels();

      /*
        Sunucu ilk parçayı basamadıysa (örneğin koleksiyon değiştiyse) liste
        boş kalmasın: ilk sayfa doğrudan akıştan çekilir.
      */
      if (!this.catalog.length) {
        this.sources[0].page = 0;
        this.loadNextPage();
      }

      /*
        Dar ekranda araç zaten "daha büyük ekran gerekli" diyor; kenar çubuğu
        gizliyken ne filtre seçenekleri ne de yeni sayfa indirilir.
      */
      const compact = () => !this.panelEl || this.panelEl.offsetParent === null;
      const warm = () => {
        if (compact()) return;
        this.ensureFacets();
        this.loadArtists();
        /*
          İlk birkaç kartın tam verisi boşta getirilir. Gerisi fareyle üzerine
          gelindiğinde yüklenir; böylece ilk tıklama da beklemesiz olur.
        */
        this.catalog.slice(0, 8).forEach((e) => this.getProduct(e.stub.handle));
      };
      if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 4000 });
      else setTimeout(warm, 1500);
      window.addEventListener('resize', () => {
        clearTimeout(this._warmTimer);
        this._warmTimer = setTimeout(warm, 400);
      });
    }

    /*
      Durum çubuğu listenin altına yapışıktır; göstermek ya da gizlemek
      kartların yerini değiştirmez.
    */
    setStreamState(state, message) {
      const text =
        message || (state === 'loading' ? 'Eserler yükleniyor…' : '');
      if (this.streamMsg) this.streamMsg.textContent = text;
      if (this.streamRetry) this.streamRetry.hidden = state !== 'error';
      if (this.streamEl) {
        this.streamEl.hidden = !text && state !== 'error';
        this.streamEl.classList.toggle('is-loading', state === 'loading');
        this.streamEl.classList.toggle('is-error', state === 'error');
      }
    }

    /*
      Filtre değişiminde ızgara boşaltılmadan iskelet hücrelerle doldurulur.
      Gerçek kartlar tek seferde yerine geçtiği için ara kare boş kalmaz.
    */
    showSkeletons(count) {
      if (!this.grid) return;
      const cell =
        '<div class="awd__skel" aria-hidden="true">' +
        '<div class="awd__skel-img"></div>' +
        '<div class="awd__skel-line"></div>' +
        '<div class="awd__skel-line awd__skel-line--short"></div>' +
        '</div>';
      this.grid.innerHTML = cell.repeat(count);
    }

    async fetchResults(scope, page) {
      const res = await fetch(this.scopeUrl(RESULTS_SECTION, scope, page), {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      });
      if (!res.ok) throw new Error(`awd results ${res.status}`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      let meta = null;
      const rawMeta = doc.querySelector('[data-awd-meta]')?.textContent;
      if (rawMeta) {
        try {
          meta = JSON.parse(rawMeta);
        } catch (e) {
          meta = null;
        }
      }
      return { meta, cards: [...doc.querySelectorAll('[data-awd-product-card]')] };
    }

    /* Filtre seçeneklerini tek sefer ısıt; panel bunlarla kurulur. */
    async ensureFacets() {
      if (this.facets.length || this._facetsPending) return this._facetsPending;
      this._facetsPending = (async () => {
        try {
          const { meta } = await this.fetchResults(this.baseScope || 'all', 1);
          if (meta) {
            this.facets = meta.facets || [];
            /* Mağaza geneli seçenekler: çok sanatçılı seçimde bunlar gösterilir */
            this.baseFacets = this.facets;
            if (meta.count != null && this.sources && this.sources.length === 1) {
              this.sources[0].count = meta.count;
              this.sources[0].pages = meta.pages;
              this.updateResultLabels();
            }
          }
        } catch (e) {
          /* facet gelmezse panel "filtre yüklenemedi" der, akış bozulmaz */
        } finally {
          this._facetsPending = null;
        }
        return this.facets;
      })();
      return this._facetsPending;
    }

    /* Sırası gelen kaynağın bir sonraki sayfası; kaynak bitince sıradakine geçilir */
    nextPending() {
      while (this.sourceIndex < this.sources.length) {
        const src = this.sources[this.sourceIndex];
        if (src.pages == null || src.page < src.pages) return src;
        this.sourceIndex += 1;
      }
      return null;
    }

    async loadNextPage() {
      if (this.loading) return false;
      const src = this.nextPending();
      if (!src) {
        this.setStreamState('done', this.catalog.length ? 'Tüm eserler yüklendi.' : '');
        return false;
      }
      this.loading = true;
      const seq = (this.loadSeq += 1);
      this.setStreamState('loading');
      try {
        const { meta, cards } = await this.fetchResults(src.scope, src.page + 1);
        if (seq !== this.loadSeq) return false; /* araya yeni filtre girdi */
        src.page += 1;
        if (meta) {
          src.pages = meta.pages;
          if (meta.count != null) src.count = meta.count;
          if (!this.facets.length) this.facets = meta.facets || [];
        }
        this.appendCards(cards);
        this.updateResultLabels();
        if (!this.nextPending()) {
          this.setStreamState('done', this.catalog.length ? 'Tüm eserler yüklendi.' : '');
        } else {
          this.setStreamState('idle');
        }
        return true;
      } catch (e) {
        if (seq === this.loadSeq) {
          this._retry = () => this.loadNextPage();
          this.setStreamState('error', 'Eserler yüklenemedi. Bağlantınızı kontrol edin.');
        }
        return false;
      } finally {
        if (seq === this.loadSeq) this.loading = false;
      }
    }

    appendCards(cards) {
      if (!this.grid || !cards.length) return;
      const frag = document.createDocumentFragment();
      const added = [];
      cards.forEach((card) => {
        const handle = card.dataset.awdHandle;
        /* İlk parça ile sunucu sıralaması birebir örtüşmeyebilir; tekrarı ele */
        if (!handle || this.seenHandles.has(handle)) return;
        const node = document.importNode(card, true);
        frag.appendChild(node);
        added.push(node);
      });
      if (!added.length) return;
      this.grid.appendChild(frag);
      this.registerCards(added);
      if (window.AlaWishlist) window.AlaWishlist.syncCards();
    }

    /* Filtre değişince listeyi baştan kur */
    async reload() {
      if (!this.grid) return;
      const seq = (this.loadSeq += 1);
      this.loading = true;
      this.catalog = [];
      this.seenHandles = new Set();
      this.sources = this.buildSources();
      this.sourceIndex = 0;
      /*
        Yenileme boyunca ızgara mevcut yüksekliğinin altına inmez. Aksi halde
        liste önce kısalır, sonuçlar gelince uzar ve alttaki durum çubuğu
        gidip gelir. İskelet sayısı da gelecek parti kadar tutulur.
      */
      const heldHeight = this.grid.offsetHeight;
      if (heldHeight) this.grid.style.minHeight = `${heldHeight}px`;
      this.showSkeletons(this.perPage);
      this.panelEl?.scrollTo({ top: 0 });
      this.setStreamState('loading');
      try {
        /* Çok kaynaklı seçimde önce say, boş sanatçıları listeden düşür */
        if (this.sources.length > 1) {
          await this.measureSources(this.sources, seq);
          if (seq !== this.loadSeq) return;
          this.sources = this.sources.filter((s) => s.count == null || s.count > 0);
          this.updateResultLabels();
        }

        const collected = [];
        let guard = 0;
        while (guard < 12) {
          guard += 1;
          const src = this.nextPending();
          if (!src) break;
          const { meta, cards } = await this.fetchResults(src.scope, src.page + 1);
          if (seq !== this.loadSeq) return;
          src.page += 1;
          if (meta) {
            src.pages = meta.pages;
            if (meta.count != null) src.count = meta.count;
            /*
              Facet sayıları tek kaynakta geçerlidir. Birden çok sanatçı
              seçiliyse gelen sayılar yalnızca son sanatçıyı anlatır, bu yüzden
              mağaza geneli seçenekler korunur ve sayılar gizlenir.
            */
            if (this.sources.length === 1 && meta.facets && meta.facets.length) {
              this.facets = meta.facets;
            } else if (this.baseFacets && this.baseFacets.length) {
              this.facets = this.baseFacets;
            }
          }
          collected.push(...cards);
          if (collected.length >= this.perPage) break;
        }

        this.grid.innerHTML = '';
        this.appendCards(collected);
        if (!this.catalog.length) {
          this.grid.innerHTML = '<p class="awd__empty">Bu filtrelerle eser bulunamadı.</p>';
        }
        this.grid.style.minHeight = '';
        this.updateResultLabels();
        this.renderFilterBody();
        this.setStreamState(this.nextPending() ? 'idle' : 'done');
      } catch (e) {
        if (seq === this.loadSeq) {
          /* Boş ızgara bırakma: iskeletleri kaldır, tekrar denenebilir bırak */
          this.grid.innerHTML =
            '<p class="awd__empty">Eserler yüklenemedi. Bağlantınızı kontrol edip yeniden deneyin.</p>';
          this.grid.style.minHeight = '';
          this._retry = () => this.reload();
          this.setStreamState('error', 'Eserler yüklenemedi.');
        }
      } finally {
        if (seq === this.loadSeq) this.loading = false;
      }
    }

    activeFilterCount() {
      let n = this.sortScope ? 1 : 0;
      n += this.selectedArtists.size;
      this.activeFilters.forEach((values) => {
        n += values.size;
      });
      return n;
    }

    updateResultLabels() {
      const badge = this.querySelector('[data-awd-filter-count]');
      if (badge) badge.textContent = `(${this.activeFilterCount()})`;
      const apply = this.querySelector('[data-awd-filter-apply]');
      if (apply) {
        const { sum, complete } = this.knownTotal();
        /* Ölçülmemiş kaynak varsa sayı "+" ile verilir, yanlış sayı gösterilmez */
        const n = complete ? sum : `${Math.max(sum, this.catalog.length)}+`;
        apply.textContent = `Sonuçları gör (${n})`;
      }
    }

    /* ---------- sanatçı listesi ---------- */

    /*
      Liste tarayıcıda saklanır ve arka planda tazelenir: panel ilk karede
      dolu açılır, mağazaya yeni sanatçı eklendiğinde de kendiliğinden
      güncellenir. Temada sabit bir sanatçı listesi tutulmaz.
    */
    readArtistCache() {
      try {
        const raw = window.localStorage.getItem(ARTISTS_CACHE_KEY);
        if (!raw) return null;
        const data = JSON.parse(raw);
        return Array.isArray(data.artists) && data.artists.length ? data.artists : null;
      } catch (e) {
        return null;
      }
    }

    writeArtistCache(artists) {
      try {
        window.localStorage.setItem(
          ARTISTS_CACHE_KEY,
          JSON.stringify({ at: Date.now(), artists })
        );
      } catch (e) {
        /* depolama kapalıysa liste yine her açılışta getirilir */
      }
    }

    setArtists(artists) {
      this.artists = artists;
      this.artistByHandle = {};
      artists.forEach((a) => {
        a._f = fold(a.t);
        this.artistByHandle[a.h] = a;
      });
      /*
        Liste sunucudan bayt sırasıyla gelir, bu yüzden É gibi harfler Z'den
        sonraya düşer. Aksan yok sayılarak sıralanır: Étienne, E'lerin arasında.
      */
      this.artists.sort((a, b) => a._f.localeCompare(b._f, 'tr'));
    }

    async loadArtists() {
      if (this._artistsPending) return this._artistsPending;
      const cached = this.readArtistCache();
      if (cached) this.setArtists(cached);

      this._artistsPending = (async () => {
        try {
          const root = window.Shopify?.routes?.root || '/';
          const res = await fetch(`${root}?section_id=${ARTISTS_SECTION}`, {
            credentials: 'same-origin',
            headers: { Accept: 'text/html' },
          });
          if (!res.ok) throw new Error(`awd artists ${res.status}`);
          const html = await res.text();
          const raw = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('[data-awd-artists]')?.textContent;
          const data = raw ? JSON.parse(raw) : null;
          const list = (data && data.artists) || [];
          if (list.length) {
            this.setArtists(list);
            this.writeArtistCache(list);
            this.renderArtistList();
          }
        } catch (e) {
          this._artistsFailed = !this.artists.length;
          this.renderArtistList();
        } finally {
          this._artistsPending = null;
        }
        return this.artists;
      })();

      /* Önbellek varsa beklemeden dön, tazeleme arka planda sürsün */
      return cached ? this.artists : this._artistsPending;
    }

    artistSectionHtml() {
      /* Varsayılan kapalı: ziyaretçi + ile açar */
      return `
        <section class="awd__f-section awd__f-section--artist" data-f-section="artist">
          <button type="button" class="awd__f-head" data-f-toggle>
            <span>Sanatçı</span>
            <span class="awd__f-sign" aria-hidden="true"></span>
          </button>
          <div class="awd__f-body">
            <input
              type="search"
              class="awd__f-search"
              data-awd-artist-search
              placeholder="Sanatçı ara"
              aria-label="Sanatçı ara"
              autocomplete="off"
              value="${escapeHtml(this.artistQuery || '')}"
            >
            <div class="awd__f-artists" data-awd-artist-list></div>
          </div>
        </section>`;
    }

    renderArtistList() {
      const wrap = this.querySelector('[data-awd-artist-list]');
      if (!wrap) return;
      if (!this.artists.length) {
        wrap.innerHTML = this._artistsFailed
          ? '<p class="awd__empty">Sanatçı listesi yüklenemedi.</p>'
          : '<p class="awd__empty">Sanatçılar yükleniyor…</p>';
        return;
      }

      const q = fold(this.artistQuery || '').trim();
      const selected = [...this.selectedArtists]
        .map((h) => this.artistByHandle[h])
        .filter(Boolean);
      const matches = this.artists.filter(
        (a) => !this.selectedArtists.has(a.h) && (!q || a._f.includes(q))
      );

      /* Liste kaydırıldıkça artar, tüm sanatçılar zaten bellekte olduğu için ağ isteği yok */
      if (!this.artistLimit) this.artistLimit = ARTIST_PAGE;
      const shown = matches.slice(0, this.artistLimit);
      const rest = matches.length - shown.length;

      const row = (a, checked) => `
        <label class="awd__f-opt">
          <input type="checkbox" data-awd-artist="${escapeHtml(a.h)}"${checked ? ' checked' : ''}>
          <span class="awd__f-mark"></span>
          <span>${escapeHtml(a.t)}</span>
          <span class="awd__f-count">(${a.n != null ? a.n : ''})</span>
        </label>`;

      let html = selected.map((a) => row(a, true)).join('');
      if (selected.length && shown.length) html += '<div class="awd__f-divider"></div>';
      html += shown.map((a) => row(a, false)).join('');

      if (!selected.length && !shown.length) {
        html = '<p class="awd__empty">Sanatçı bulunamadı.</p>';
      } else if (rest > 0) {
        html += `<p class="awd__f-more">${rest} sanatçı daha, kaydırarak görebilirsiniz.</p>`;
      }

      /* Kaydırma konumu korunur, yoksa liste her büyümede başa dönerdi */
      const keepTop = wrap.scrollTop;
      wrap.innerHTML = html;
      wrap.scrollTop = keepTop;

      if (!wrap.dataset.awdScrollBound) {
        wrap.dataset.awdScrollBound = '1';
        wrap.addEventListener('scroll', () => {
          if (wrap.scrollTop + wrap.clientHeight < wrap.scrollHeight - 80) return;
          const total = this.artists.filter(
            (a) =>
              !this.selectedArtists.has(a.h) &&
              (!this.artistQuery || a._f.includes(fold(this.artistQuery).trim()))
          ).length;
          if (this.artistLimit >= total) return;
          this.artistLimit += ARTIST_PAGE;
          this.renderArtistList();
        });
      }
      wrap.querySelectorAll('input[data-awd-artist]').forEach((input) => {
        input.addEventListener('change', () => {
          const handle = input.dataset.awdArtist;
          if (input.checked) this.selectedArtists.add(handle);
          else this.selectedArtists.delete(handle);
          this.updateResultLabels();
          this.renderArtistList();
          this.queueReload();
        });
      });
    }

    bindArtistSearch() {
      const input = this.querySelector('[data-awd-artist-search]');
      if (!input) return;
      input.addEventListener('input', () => {
        this.artistQuery = input.value;
        /* Yeni aramada liste baştan başlar */
        this.artistLimit = ARTIST_PAGE;
        /* Yazarken her tuşta liste yeniden çizilir, ağ isteği yapılmaz */
        this.renderArtistList();
      });
    }

    /* ---------- filtre paneli ---------- */

    bindFilter() {
      this.filterEl = this.querySelector('[data-awd-filter]');
      this.filterBody = this.querySelector('[data-awd-filter-body]');
      this.querySelector('[data-awd-filter-open]')?.addEventListener('click', async () => {
        this.filterEl?.removeAttribute('hidden');
        this.renderFilterBody();
        this.loadArtists();
        await this.ensureFacets();
        this.renderFilterBody();
      });
      this.querySelector('[data-awd-filter-close]')?.addEventListener('click', () => {
        this.filterEl?.setAttribute('hidden', '');
      });
      this.querySelector('[data-awd-filter-apply]')?.addEventListener('click', () => {
        this.filterEl?.setAttribute('hidden', '');
        this.setActiveTab('products');
      });
      this.querySelector('[data-awd-filter-clear]')?.addEventListener('click', () => {
        this.activeFilters = new Map();
        this.selectedArtists = new Set();
        this.artistQuery = '';
        this.sortScope = '';
        this.renderFilterBody();
        this.reload();
      });
    }

    orderedFacets() {
      const byParam = {};
      (this.facets || []).forEach((f) => {
        if (!f || !f.param || SKIP_FACET_RE.test(f.param)) return;
        if (SKIP_KOLEKSIYON_TURU_RE.test(String(f.label || '')) || SKIP_KOLEKSIYON_TURU_RE.test(String(f.param || ''))) {
          return;
        }
        let values = f.values || [];
        if (f.param === 'filter.p.m.filtre.yon') {
          values = values.filter(
            (v) => !HIDDEN_YON_RE.test(String(v.label || '')) && !HIDDEN_YON_RE.test(String(v.value || ''))
          );
        }
        if (!values.length) return;
        byParam[f.param] = { ...f, values };
      });
      const ordered = [];
      FACET_ORDER.forEach((param) => {
        if (byParam[param]) {
          ordered.push(byParam[param]);
          delete byParam[param];
        }
      });
      Object.keys(byParam)
        .filter((param) => param.startsWith('filter.p.m.'))
        .sort()
        .forEach((param) => ordered.push(byParam[param]));
      return ordered;
    }

    renderFilterBody() {
      if (!this.filterBody) return;
      /*
        Panel filtre değiştikçe yeniden çizilir. Arama kutusundaki yazı ve
        imleç korunmazsa ziyaretçi her seçimde yazdığını kaybeder.
      */
      const search = this.querySelector('[data-awd-artist-search]');
      const hadFocus = search && document.activeElement === search;
      const caret = search ? search.selectionStart : null;

      const block = (id, title, inner, open) => `
        <section class="awd__f-section${open ? ' is-open' : ''}" data-f-section="${id}">
          <button type="button" class="awd__f-head" data-f-toggle>
            <span>${escapeHtml(title)}</span>
            <span class="awd__f-sign" aria-hidden="true"></span>
          </button>
          <div class="awd__f-body">${inner}</div>
        </section>`;

      const radio = (name, value, label, checked) => `
        <label class="awd__f-opt">
          <input type="radio" name="${name}" value="${escapeHtml(value)}"${checked ? ' checked' : ''}>
          <span class="awd__f-mark awd__f-mark--radio"></span>
          <span>${escapeHtml(label)}</span>
        </label>`;

      const checkbox = (param, value, label, checked, count) => `
        <label class="awd__f-opt${count === 0 && !checked ? ' is-empty' : ''}">
          <input type="checkbox" data-f-param="${escapeHtml(param)}" value="${escapeHtml(value)}"${
            checked ? ' checked' : ''
          }>
          <span class="awd__f-mark"></span>
          <span>${escapeHtml(label)}</span>
          ${count != null ? `<span class="awd__f-count">(${count})</span>` : ''}
        </label>`;

      /* Ürünü olmayan kapsam seçeneği gösterilmez, liste boşalmasın */
      const counts = String(this.dataset.scopeCounts || '')
        .split(',')
        .map((n) => Number(n || 0));
      const sortHtml = SCOPE_OPTIONS.filter((o, i) => !o.value || counts[i - 1] > 0)
        .map((o) => radio('awd-sort', o.value, o.label, this.sortScope === o.value))
        .join('');

      /* Çok sanatçılı seçimde sayılar birleşimi anlatmadığı için gösterilmez */
      const showCounts = !this.selectedArtists.size || this.selectedArtists.size === 1;
      const facets = this.orderedFacets();
      const facetHtml = facets
        .map((f) => {
          const selected = this.activeFilters.get(f.param) || new Set();
          const inner = (f.values || [])
            .map((v) =>
              checkbox(f.param, v.value, v.label, selected.has(v.value), showCounts ? v.count : null)
            )
            .join('');
          const title = FACET_LABELS[f.param] || f.label;
          return block(f.param, title, inner || '<p class="awd__empty">Seçenek yok.</p>', false);
        })
        .join('');

      const pending = !facets.length
        ? block('yukleniyor', 'Filtreler', '<p class="awd__empty">Filtreler yükleniyor…</p>', true)
        : '';

      this.filterBody.innerHTML =
        block('sort', 'Koleksiyon türü', sortHtml, true) +
        this.artistSectionHtml() +
        facetHtml +
        pending;

      this.bindArtistSearch();
      this.renderArtistList();
      if (hadFocus) {
        const next = this.querySelector('[data-awd-artist-search]');
        next?.focus();
        if (caret != null) next?.setSelectionRange(caret, caret);
      }

      this.filterBody.querySelectorAll('[data-f-toggle]').forEach((btn) => {
        btn.addEventListener('click', () => {
          btn.closest('.awd__f-section')?.classList.toggle('is-open');
        });
      });

      this.filterBody.querySelectorAll('input[name="awd-sort"]').forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.checked) return;
          this.sortScope = input.value;
          this.queueReload();
        });
      });

      this.filterBody.querySelectorAll('input[data-f-param]').forEach((input) => {
        input.addEventListener('change', () => {
          const param = input.dataset.fParam;
          const set = this.activeFilters.get(param) || new Set();
          if (input.checked) set.add(input.value);
          else set.delete(input.value);
          if (set.size) this.activeFilters.set(param, set);
          else this.activeFilters.delete(param);
          this.updateResultLabels();
          this.queueReload();
        });
      });
    }

    /*
      Arka arkaya kutu işaretleyen ziyaretçi için tek istek yeter;
      kısa bir bekleme sunucuya gereksiz yük bindirmeyi önler.
    */
    queueReload() {
      clearTimeout(this._reloadTimer);
      this._reloadTimer = setTimeout(() => this.reload(), 260);
    }

    /* ---------- tabs ---------- */

    setActiveTab(tab) {
      this.querySelectorAll('[data-awd-tab]').forEach((b) =>
        b.classList.toggle('is-active', b.dataset.awdTab === tab)
      );
      this.querySelectorAll('[data-awd-panel]').forEach((p) => {
        p.classList.toggle('is-active', p.dataset.awdPanel === tab);
      });
      if (tab === 'favorites') this.renderFavorites();
    }

    bindTabs() {
      this.querySelectorAll('[data-awd-tab]').forEach((btn) => {
        btn.addEventListener('click', () => this.setActiveTab(btn.dataset.awdTab));
      });
    }

    /* ---------- favorites ---------- */

    favHandles() {
      const wl = window.AlaWishlist;
      if (!wl) return [];
      const seen = new Set();
      const handles = [];
      (wl.lists() || []).forEach((l) => {
        (l.items || []).forEach((it) => {
          if (it.handle && !seen.has(it.handle)) {
            seen.add(it.handle);
            handles.push(it.handle);
          }
        });
      });
      return handles;
    }

    updateFavCount() {
      const el = this.querySelector('[data-awd-fav-count]');
      if (!el) return;
      const wl = window.AlaWishlist;
      const n =
        wl && typeof wl.totalCount === 'function' ? wl.totalCount() : this.favHandles().length;
      el.textContent = `(${n})`;
    }

    bindWishlist() {
      this.updateFavCount();
      const rerender = () => {
        this.updateFavCount();
        if (window.AlaWishlist) window.AlaWishlist.syncCards();
        const panel = this.querySelector('[data-awd-panel="favorites"]');
        if (panel?.classList.contains('is-active')) this.renderFavorites();
      };
      if (window.AlaWishlist) window.AlaWishlist.on('change', rerender);
      document.addEventListener('ala-wl-session', rerender);
    }

    async renderFavorites() {
      if (!this.favGrid) return;
      const wl = window.AlaWishlist;
      if (!wl || !wl.isLoggedIn()) {
        const url = wl ? wl.loginUrl() : '/account/login';
        this.favGrid.innerHTML = `<p class="awd__empty">Favorilerinizi görmek için <a href="${url}">giriş yapın</a>.</p>`;
        return;
      }
      const handles = this.favHandles();
      this.updateFavCount();
      if (!handles.length) {
        this.favGrid.innerHTML =
          '<p class="awd__empty">Henüz favori ürününüz yok. Ürün kartlarındaki kalbe dokunarak favorilerinize ekleyin.</p>';
        return;
      }
      this.favGrid.innerHTML = '<p class="awd__empty">Favoriler yükleniyor…</p>';
      const token = (this._favToken = Symbol('fav'));
      const products = [];
      for (const handle of handles) {
        const product = await this.getProduct(handle);
        if (product) products.push(product);
      }
      if (this._favToken !== token) return; /* eski istek, yenisi geldi */

      this.favGrid.innerHTML = '';
      products.forEach((product) => {
        this._favProducts[product.handle] = product;
        const card = document.createElement('article');
        card.className = 'awd__card';
        card.dataset.awdFavHandle = product.handle;
        const img = product.featuredImage || '';
        const orient = orientationOf(product.aspect) || 'dikey';
        const artwork = artworkTitleOf(product);
        card.dataset.awdOrient = orient;
        card.innerHTML = `
          <button type="button" class="awd__card-add ${cardOrientClass(product.aspect)}" data-awd-add aria-label="${escapeHtml(artwork)} duvara ekle">
            ${
              img
                ? `<span class="awd__card-mat"><span class="awd__card-art"><img class="awd__card-img" src="${escapeHtml(img)}" alt="${escapeHtml(artwork)}" loading="lazy"></span></span>`
                : ''
            }
            ${CARD_HOVER}
          </button>
          <div class="awd__card-meta">
            <div class="awd__card-meta-row">
              <p class="awd__card-title" title="${escapeHtml(artwork)}">${escapeHtml(artwork)}</p>
              <button type="button" class="card__wishlist-btn awd__card-fav is-wishlisted"
                data-product-id="${escapeHtml(product.id)}"
                data-product-handle="${escapeHtml(product.handle)}"
                data-product-title="${escapeHtml(artwork)}"
                aria-label="Favorilerden çıkar">${HEART_SVG}</button>
            </div>
            <p class="awd__card-price">${money(minVariantPrice(product), this)}</p>
          </div>`;
        this.favGrid.appendChild(card);
      });
      if (window.AlaWishlist) window.AlaWishlist.syncCards();
    }

    /* ---------- add to wall ---------- */

    bindAdd() {
      /*
        Fareyle kartın üzerine gelindiğinde tam ürün önden getirilir; tıklama
        anında ağ beklemesi kalmaz ve ekleme eskisi gibi anında hissedilir.
      */
      this.addEventListener(
        'pointerenter',
        (e) => {
          const card = e.target.closest?.('[data-awd-product-card]');
          if (card?.dataset.awdHandle) this.getProduct(card.dataset.awdHandle);
        },
        true
      );

      this.addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-awd-add]');
        if (!btn) return;
        const card = btn.closest('[data-awd-product-card], [data-awd-fav-handle]');
        if (!card) return;
        const handle = card.dataset.awdFavHandle || card.dataset.awdHandle;
        if (!handle) return;
        /*
          Kartın ekranda gösterdiği görsel adresi: tarayıcı önbelleğinde
          çözülmüş olduğu için poster ilk karede bununla basılır.
        */
        const cardImg = card.querySelector('.awd__card-img');
        const previewSrc = cardImg?.currentSrc || cardImg?.src || null;
        if (card.dataset.awdFavHandle && this._favProducts[handle]) {
          this.addProduct(this._favProducts[handle], { previewSrc });
          return;
        }
        if (card.classList.contains('is-loading')) return;
        card.classList.add('is-loading');
        try {
          const product = await this.getProduct(handle);
          if (product) this.addProduct(product, { previewSrc });
          else window.alert('Bu eser şu anda yüklenemedi. Lütfen tekrar deneyin.');
        } finally {
          card.classList.remove('is-loading');
        }
      });
    }

    bindFooter() {
      this.querySelector('[data-awd-clear]')?.addEventListener('click', () => {
        if (!this.wall.length) return;
        if (!window.confirm('Duvarı temizlemek istiyor musunuz?')) return;
        this.wall = [];
        this.selectedId = null;
        this.stage.innerHTML = '';
        this.closeConfigure();
        this.renderShopList();
        this.updateTotals();
      });

      this.querySelector('[data-awd-change-bg]')?.addEventListener('click', () => {
        this.querySelector('[data-awd-bg-modal]')?.removeAttribute('hidden');
      });
      this.querySelector('[data-awd-bg-close]')?.addEventListener('click', () => {
        this.querySelector('[data-awd-bg-modal]')?.setAttribute('hidden', '');
      });

      this.querySelector('[data-awd-configure-close]')?.addEventListener('click', () => this.closeConfigure());
      this.shopBtn?.addEventListener('click', () => this.openShopDrawer());
    }

    renderBgChoices() {
      const wrap = this.querySelector('[data-awd-bg-choices]');
      if (!wrap) return;
      wrap.innerHTML = '';
      /* Thumbnail = sadece img; tüm .awd__bg klonu opacity:0 yüzünden boş görünürdü */
      this.querySelectorAll('[data-awd-bg-item]').forEach((item, index) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'awd__bg-choice';
        if (item.classList.contains('is-active')) btn.classList.add('is-selected');
        btn.title = item.dataset.label || `Arka plan ${index + 1}`;
        const src = item.querySelector('.awd__bg-img, .awd__bg-fallback, img');
        if (src) {
          const thumb = src.cloneNode(true);
          thumb.removeAttribute('loading');
          thumb.setAttribute('loading', 'eager');
          thumb.setAttribute('decoding', 'async');
          btn.appendChild(thumb);
        }
        btn.addEventListener('click', () => {
          this.querySelectorAll('[data-awd-bg-item]').forEach((el) => el.classList.remove('is-active'));
          item.classList.add('is-active');
          wrap.querySelectorAll('.awd__bg-choice').forEach((el) => el.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          this.querySelector('[data-awd-bg-modal]')?.setAttribute('hidden', '');
        });
        wrap.appendChild(btn);
      });
    }

    async addProduct(product, preset) {
      const sizes = uniqueOptionValues(product, SIZE_OPTION_NAMES);
      const frames = uniqueOptionValues(product, FRAME_OPTION_NAMES);
      /* Yerleşim varyanttan değil sabit kip listesinden gelir */
      const placements = PLACEMENT_MODES;

      let selected;
      if (preset && preset.selected) {
        selected = {
          size: sizes.includes(preset.selected.size) ? preset.selected.size : sizes[0] || this.defaultSize,
          frame: frames.includes(preset.selected.frame)
            ? preset.selected.frame
            : preferBlackFrame(frames),
          placement: placements.includes(preset.selected.placement)
            ? preset.selected.placement
            : preferOrtala(placements),
        };
      } else {
        const smart = resolveSmartDefaults(product, sizes, placements, this.defaultSize);
        selected = {
          size: smart.size,
          frame: preferBlackFrame(frames),
          placement: smart.placement,
        };
      }
      const variant = findVariant(product, selected) || product.variants?.[0];
      if (!variant) return;

      const item = {
        uid: `p${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`,
        product,
        selected,
        variantId: variant.id,
        price: variant.price,
        image: resolveWallImage(product, selected).url,
        /* Kart görseli: posterin ilk karesinde kullanılır (bkz. renderPoster) */
        previewImage: (preset && preset.previewSrc) || null,
        z: this.wall.length + 1,
      };
      /*
        Konum, boyut ve çerçeve belli olduktan sonra hesaplanır: yerleştirme
        posterin duvardaki gerçek ölçüsünü bilmek zorunda.
      */
      const spot = this.nextPosterSpot(item);
      item.x = preset && preset.x != null ? preset.x : spot.x;
      item.y = preset && preset.y != null ? preset.y : spot.y;
      this.wall.push(item);
      this.renderPoster(item);
      if (!preset || !preset.silent) {
        this.selectPoster(item.uid);
        this.openConfigure(item.uid);
      }
      this.renderShopList();
      this.updateTotals();
    }

    /*
      Yeni posterin duvardaki yeri.

      Eskiden merkeze yakın rastgele bir nokta veriliyordu (%50 ± 4). İki eser
      arka arkaya eklendiğinde ikincisi birincisinin neredeyse tam üstüne
      düşüyor, alttaki tamamen kapanıyordu: araç ilk eseri düşürmüş gibi
      görünüyordu. Artık yer rastgele değil, sıralı bir asma düzeninden
      seçilir: önce duvarın ortası, sonra ortanın sağı ve solu, sonra üst ve
      alt sıra. Boş bulunan ilk nokta kullanılır, böylece eserler galeri
      duvarı gibi yan yana dizilir.

      Duvar dolduğunda hiçbir nokta tam boş kalmaz. O durumda aynı adaylar
      arasından, mevcut eserlerin en azını kapatan nokta seçilir; yeni eser
      en üstte durur, alttaki eser mümkün olan en büyük bölümüyle görünür
      kalır ve ziyaretçi sürükleyerek ayırabilir. Ölçümde 16 posterlik dolu
      duvarda en kötü örtüşme %98,7'den %41'e indi; altı posterlik olağan
      kullanımda örtüşme hiç kalmadı.
    */
    nextPosterSpot(item) {
      const fallback = { x: 50, y: 46 };
      /* Sahne ölçülemiyorsa (panel kapalı, araç gizli) merkez kullanılır */
      const stageRect = this.stage?.getBoundingClientRect?.();
      if (!stageRect || !stageRect.width || !stageRect.height) return fallback;

      const pctOf = (size) => {
        const dims = this.cmToPx(size);
        return {
          w: (dims.width / stageRect.width) * 100,
          h: (dims.height / stageRect.height) * 100,
        };
      };

      const self = pctOf(item.selected.size);
      if (!(self.w > 0) || !(self.h > 0)) return fallback;

      const others = this.wall
        .filter((other) => other.uid !== item.uid)
        .map((other) => ({ x: other.x, y: other.y, ...pctOf(other.selected.size) }));

      /* Aradaki boşluk: posterler bitişik değil, ayrı ayrı okunsun */
      const gapX = Math.max(self.w * 0.18, 2);
      const gapY = Math.max(self.h * 0.16, 2);

      /* Görünür boşluk dahil çakışma: bu noktaya poster asılabilir mi */
      const overlaps = (x, y) =>
        others.some(
          (o) =>
            Math.abs(x - o.x) < (self.w + o.w) / 2 + gapX &&
            Math.abs(y - o.y) < (self.h + o.h) / 2 + gapY
        );

      /*
        Duvar dolduğunda kullanılır: bu noktaya asılırsa hangi eser en çok
        kapanır. Küçük olanın alanına oranlanır, çünkü asıl sorun küçük eserin
        tamamen gizlenmesi.
      */
      const worstCoverage = (x, y) => {
        let worst = 0;
        others.forEach((o) => {
          const ow = Math.max(0, Math.min(x + self.w / 2, o.x + o.w / 2) - Math.max(x - self.w / 2, o.x - o.w / 2));
          const oh = Math.max(0, Math.min(y + self.h / 2, o.y + o.h / 2) - Math.max(y - self.h / 2, o.y - o.h / 2));
          const area = ow * oh;
          if (area <= 0) return;
          const smaller = Math.min(self.w * self.h, o.w * o.h);
          if (smaller > 0) worst = Math.max(worst, area / smaller);
        });
        return worst;
      };

      /* Poster tümüyle duvarın içinde kalmalı; sınırlar sürüklemeyle aynı */
      const minX = self.w / 2 + 2;
      const maxX = 98 - self.w / 2;
      const minY = self.h / 2 + 2;
      const maxY = 98 - self.h / 2;
      /* Duvardan geniş ya da uzun poster: ortalamaktan başka seçenek yok */
      if (minX > maxX || minY > maxY) return fallback;

      const stepX = self.w + gapX;
      const stepY = self.h + gapY;

      /*
        Sıralar göz hizasından başlar, sonra üst ve alt sıraya çıkar. Sınırın
        dışına düşen sıra atılmaz, sınıra çekilir: aksi halde büyük panoramik
        eserlerde hiçbir sıra kalmıyor ve yerleştirme kademeye düşüyordu.
      */
      const rows = [];
      [46, 46 - stepY, 46 + stepY, 46 - stepY * 2, 46 + stepY * 2].forEach((raw) => {
        const y = Math.min(maxY, Math.max(minY, raw));
        if (!rows.some((existing) => Math.abs(existing - y) < 0.5)) rows.push(y);
      });

      /*
        Yatay adaylar duvarın ortasından dışa doğru taranır. Adım poster
        genişliğinin yarısı: geniş eserlerde de yeterli aday kalır, aradaki
        görünür boşluğu zaten örtüşme kontrolü garanti eder. Ortadan dışa
        sıra, eserleri ortada toplayıp simetrik dizer.
      */
      const xs = [];
      const pushX = (raw) => {
        const x = Math.min(maxX, Math.max(minX, raw));
        if (!xs.some((existing) => Math.abs(existing - x) < 0.5)) xs.push(x);
      };
      const scan = Math.max(stepX / 2, 3);
      for (let d = 0; d <= 100; d += scan) {
        pushX(50 - d);
        if (d > 0) pushX(50 + d);
      }
      pushX(minX);
      pushX(maxX);

      for (const rowY of rows) {
        for (const x of xs) {
          if (!overlaps(x, rowY)) return { x, y: rowY };
        }
      }

      /*
        Duvarda tam boş nokta kalmadı. Rastgele ya da son posterin üstüne
        atmak yerine aynı aday kümesi içinde en az kapatan nokta seçilir:
        yeni eser en üstte durur, altındaki eser mümkün olan en büyük
        bölümüyle görünür kalır ve ziyaretçi sürükleyerek ayırabilir.
        Adaylar göz hizasından ve ortadan başladığı için sonuç yine
        bilinçli bir asma düzeni gibi okunur.
      */
      let bestX = Math.min(maxX, Math.max(minX, 50));
      let bestY = Math.min(maxY, Math.max(minY, 46));
      let bestCoverage = Infinity;
      for (const rowY of rows) {
        for (const x of xs) {
          const coverage = worstCoverage(x, rowY);
          if (coverage < bestCoverage) {
            bestCoverage = coverage;
            bestX = x;
            bestY = rowY;
          }
        }
      }
      return { x: bestX, y: bestY };
    }

    cmToPx(sizeLabel) {
      const stageRect = this.stage.getBoundingClientRect();
      const parsed = parseSizeCm(sizeLabel) || { w: 50, h: 70 };
      const pxPerCm = stageRect.width / this.wallWidthCm;
      return {
        width: parsed.w * pxPerCm,
        height: parsed.h * pxPerCm,
      };
    }

    renderPoster(item) {
      let el = this.stage.querySelector(`[data-uid="${item.uid}"]`);
      if (!el) {
        el = document.createElement('div');
        el.className = 'awd__poster';
        el.dataset.uid = item.uid;
        el.innerHTML = `
          <div class="awd__poster-inner">
            <img class="awd__poster-art" alt="" draggable="false" />
          </div>
          <div class="awd__poster-frame" aria-hidden="true"></div>
          <div class="awd__poster-controls">
            <button type="button" class="awd__poster-btn" data-edit title="Düzenle" aria-label="Düzenle">
              <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
            </button>
            <button type="button" class="awd__poster-btn" data-delete title="Sil" aria-label="Sil">
              <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>
            </button>
          </div>
        `;
        this.stage.appendChild(el);
        el.querySelector('[data-edit]')?.addEventListener('click', (e) => {
          e.stopPropagation();
          this.selectPoster(item.uid);
          this.openConfigure(item.uid);
        });
        el.querySelector('[data-delete]')?.addEventListener('click', (e) => {
          e.stopPropagation();
          this.removePoster(item.uid);
        });
        el.addEventListener('pointerdown', (e) => this.onPosterPointerDown(e, item.uid));
      }

      const dims = this.cmToPx(item.selected.size);
      el.style.width = `${dims.width}px`;
      el.style.height = `${dims.height}px`;
      el.style.left = `${item.x}%`;
      el.style.top = `${item.y}%`;
      el.style.zIndex = String(item.z);

      const inner = el.querySelector('.awd__poster-inner');
      const img = el.querySelector('.awd__poster-art');
      const frameEl = el.querySelector('.awd__poster-frame');
      inner.dataset.frame = item.selected.frame;
      const placement = item.selected.placement || 'Tam Oturt';
      inner.dataset.placement = placement;
      img.dataset.placement = placement;
      const resolved = resolveWallImage(item.product, item.selected);
      item.image = resolved.url;
      item._synthMat = !!resolved.synthMat;
      /*
        Poster boş bir çerçeve olarak belirmemeli. Ürün kartındaki görsel
        tarayıcıda çözülmüş halde durduğu için ilk kare onunla basılır: eser
        daha ilk karede doğru çerçeve, paspas ve oranla tam görünür. Duvar
        ölçüsündeki kopya arka planda inip çözüldükten sonra sessizce yerine
        geçer; iki adres aynı eserin aynı kırpımı olduğu için ne konum ne
        ölçek değişir, yalnızca netlik artar.

        Kart görseli yalnızca çerçevenin görsele gömülü olmadığı durumda
        kullanılır; gömülü çerçevede (baked) kart görseli çerçevesiz olduğu
        için yerine geçme gözle görülür bir değişim olurdu.
      */
      const nextSrc = resolved.url || '';
      const artSeq = (item._artSeq = (item._artSeq || 0) + 1);
      if (img.dataset.awdSrc !== nextSrc) {
        img.dataset.awdSrc = nextSrc;
        const painted = img.naturalWidth > 0;
        const preview = !painted && !resolved.baked && item.previewImage ? item.previewImage : null;
        if (preview && preview !== nextSrc) {
          img.src = preview;
          const full = new Image();
          const swap = () => {
            /* Bu arada boyut, çerçeve ya da yerleşim değiştiyse dokunulmaz */
            if (item._artSeq !== artSeq || img.dataset.awdSrc !== nextSrc) return;
            img.src = nextSrc;
          };
          full.onload = () => {
            if (full.decode) full.decode().then(swap).catch(swap);
            else swap();
          };
          full.onerror = () => {
            /* Ölçülü kopya gelmezse kart görseli duvarda kalır, poster kaybolmaz */
          };
          full.src = nextSrc;
        } else {
          img.src = nextSrc;
        }
      }
      img.alt = item.product.title || '';

      const framed = !isFrameless(item.selected.frame);
      const useOverlay = framed && !resolved.baked;
      item._overlayFrame = useOverlay;
      if (frameEl) {
        if (useOverlay) {
          const stageRect = this.stage.getBoundingClientRect();
          const pxPerCm = stageRect.width / this.wallWidthCm;
          const lipPx = (TPC_FRAME_LIP_CM * pxPerCm).toFixed(2);
          frameEl.style.display = 'block';
          frameEl.style.border = `${lipPx}px solid ${FRAME_COLORS[item.selected.frame] || '#1a1a1a'}`;
          frameEl.style.setProperty('--awd-lip', `${lipPx}px`);
        } else {
          frameEl.style.display = 'none';
          frameEl.style.border = '0';
        }
      }

      const cropTop = normalizeTags(item.product).includes('ustten-koru');
      const applyFill = () => {
        const nw = img.naturalWidth;
        const nh = img.naturalHeight;
        const boxW = inner.clientWidth;
        const boxH = inner.clientHeight;
        const tuck = useOverlay ? TPC_TUCK_SCALE : 1;

        /*
          Ortala: paspas rengi kağıt baskı ölçüsünde, eser paspas kuralının
          verdiği kutuya ortalanır. Kutu ölçekle değil genişlik/yükseklik ile
          veriliyor: kural ileride eşit genişliğe dönerse iki kenar farklı
          oranda daralacak, tek bir scale değeriyle bu anlatılamazdı.
        */
        if (resolved.synthMat) {
          inner.style.background = window.AlaPaspas.kagitRenk || '#f4f1ea';
          const kutu = matEserKutusu(boxW, boxH);
          const eserG = kutu.g * tuck;
          const eserY = kutu.y * tuck;
          img.style.objectFit = 'contain';
          img.style.objectPosition = 'center center';
          img.style.position = 'absolute';
          img.style.left = '50%';
          img.style.top = '50%';
          img.style.width = `${eserG.toFixed(2)}px`;
          img.style.height = `${eserY.toFixed(2)}px`;
          img.style.transform = 'translate(-50%, -50%)';
          item._matKutu = { g: eserG, y: eserY };
          item._matTuck = tuck;
          item._fillScale = null;
          return;
        }

        /* Tam Oturt: Ortala'dan dönerken kutu ölçüleri geri alınır */
        item._matKutu = null;
        img.style.position = '';
        img.style.left = '';
        img.style.top = '';
        img.style.width = '';
        img.style.height = '';
        img.style.objectPosition = cropTop ? 'center top' : 'center center';
        img.style.transformOrigin = cropTop ? 'center top' : 'center center';
        inner.style.background = 'transparent';
        let cover = 1;
        if (nw && nh && boxW && boxH) {
          const imgRatio = nw / nh;
          const boxRatio = boxW / boxH;
          cover = imgRatio < boxRatio ? boxRatio / imgRatio : imgRatio / boxRatio;
        }
        const scale = Math.max(Math.max(cover, printFillScale(item.selected.size)) * tuck, 1.006);
        img.style.transform = `scale(${scale.toFixed(4)})`;
        item._fillScale = scale;
      };
      img.style.objectFit = 'contain';
      img.style.objectPosition = cropTop ? 'center top' : 'center center';
      img.style.transformOrigin = cropTop ? 'center top' : 'center center';
      img.dataset.crop = cropTop ? 'top' : 'center';
      inner.dataset.crop = cropTop ? 'top' : 'center';
      inner.classList.toggle('cfp-crop-top', cropTop);
      inner.style.overflow = 'hidden';
      if (img.complete && img.naturalWidth) applyFill();
      else img.onload = applyFill;
    }

    selectPoster(uid) {
      this.selectedId = uid;
      this.stage.querySelectorAll('.awd__poster').forEach((el) => {
        el.classList.toggle('is-selected', el.dataset.uid === uid);
      });
    }

    removePoster(uid) {
      this.wall = this.wall.filter((i) => i.uid !== uid);
      this.stage.querySelector(`[data-uid="${uid}"]`)?.remove();
      if (this.selectedId === uid) {
        this.selectedId = null;
        this.closeConfigure();
      }
      this.renderShopList();
      this.updateTotals();
    }

    openConfigure(uid) {
      const item = this.wall.find((i) => i.uid === uid);
      if (!item) return;
      const sizes = uniqueOptionValues(item.product, SIZE_OPTION_NAMES);
      const frames = uniqueOptionValues(item.product, FRAME_OPTION_NAMES);
      /* Yerleşim varyanttan değil sabit kip listesinden gelir */
      const placements = PLACEMENT_MODES;

      /*
        Kırpma notu: Tam Oturt'ta eser kağıdı kapladığı için uzun ekseninden
        kesilir, kesilen oran eşiği aşarsa müşteriye söylenir. Eşik ve kayıp
        hesabı paspas-kurali.js'te, ürün sayfasıyla aynı yerde.

        Yer, merdivende en az bir basamak eşiği aşıyorsa ayrılır ve boş da
        olsa korunur; böylece müşteri ölçüler arasında gezerken panelin altı
        oynamaz. Hiçbir basamak aşmıyorsa kutu hiç basılmaz.
      */
      const eserOran = item.product.aspect || null;
      const kayipOlan = (s) => {
        const o = window.AlaPaspas.baskiOrani(s);
        return o && eserOran ? window.AlaPaspas.kirpmaUyarisi(eserOran, o) : false;
      };
      const notGerek = sizes.some(kayipOlan);
      let notMetni = '';
      if (notGerek && item.selected.placement === 'Tam Oturt' && kayipOlan(item.selected.size)) {
        const secOran = window.AlaPaspas.baskiOrani(item.selected.size);
        const eksen = eserOran > secOran ? 'yanlardan' : 'alt ve üstten';
        notMetni = `Bu ölçüde eserin ${eksen} bir bölümü kesilir. Eserin tamamını görmek için ortala yerleşimini seçebilirsiniz.`;
      }

      this.configureBody.innerHTML = `
        <h2 class="awd__cfg-title">${item.product.title}</h2>
        <section class="awd__cfg-section">
          <h3 class="awd__cfg-heading">Boyut</h3>
          <div class="awd__cfg-chips" data-cfg="size">
            ${sizes
              .map(
                (s) =>
                  `<button type="button" class="awd__cfg-chip${s === item.selected.size ? ' is-active' : ''}" data-value="${s}">${s}</button>`
              )
              .join('')}
          </div>
          ${notGerek ? `<p class="awd__cfg-note" role="status">${notMetni}</p>` : ''}
        </section>
        <section class="awd__cfg-section">
          <h3 class="awd__cfg-heading">Çerçeve</h3>
          <div class="awd__cfg-swatches" data-cfg="frame">
            ${frames
              .map(
                (f) =>
                  `<button type="button" class="awd__cfg-swatch${f === item.selected.frame ? ' is-active' : ''}" data-frame="${f}" data-value="${f}" title="${f}" aria-label="${f}"></button>`
              )
              .join('')}
          </div>
        </section>
        <section class="awd__cfg-section">
          <h3 class="awd__cfg-heading">Baskı yerleşimi</h3>
          <div class="awd__cfg-chips" data-cfg="placement">
            ${placements
              .map((p) => {
                const label =
                  p === 'Tam Oturt'
                    ? 'Eseri baskı ölçüsüne tam oturt'
                    : p === 'Ortala'
                      ? 'Eseri baskı ölçüsüne ortala'
                      : p;
                return `<button type="button" class="awd__cfg-chip${p === item.selected.placement ? ' is-active' : ''}" data-value="${p}">${label}</button>`;
              })
              .join('')}
          </div>
        </section>
      `;

      this.configureBody.querySelectorAll('[data-cfg]').forEach((group) => {
        group.querySelectorAll('[data-value]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const key = group.dataset.cfg;
            item.selected[key] = btn.dataset.value;
            const variant = findVariant(item.product, item.selected);
            if (variant) {
              item.variantId = variant.id;
              item.price = variant.price;
            }
            item.image = resolveWallImage(item.product, item.selected).url;
            this.renderPoster(item);
            this.openConfigure(uid);
            this.renderShopList();
            this.updateTotals();
          });
        });
      });

      this.configureEl.removeAttribute('hidden');
    }

    closeConfigure() {
      this.configureEl?.setAttribute('hidden', '');
    }

    /* ---------- shop drawer (Duvarı Satın Al) ---------- */

    bindShopDrawer() {
      this.shopDrawer = this.querySelector('[data-awd-shop-drawer]');
      this.shopList = this.querySelector('[data-awd-shop-list]');
      this.querySelectorAll('[data-awd-shop-close]').forEach((el) =>
        el.addEventListener('click', () => this.shopDrawer?.setAttribute('hidden', ''))
      );
      this.querySelector('[data-awd-shop-add]')?.addEventListener('click', () => this.addWallToCart());
    }

    openShopDrawer() {
      if (!this.wall.length) return;
      this.renderShopList();
      this.shopDrawer?.removeAttribute('hidden');
    }

    renderShopList() {
      if (!this.shopList) return;
      const count = this.querySelector('[data-awd-shop-count]');
      if (count) count.textContent = `(${this.wall.length})`;
      const subtotal = this.querySelector('[data-awd-shop-subtotal]');
      if (subtotal) {
        const total = this.wall.reduce((sum, item) => sum + Number(item.price || 0), 0);
        subtotal.textContent = money(total, this);
      }
      if (!this.wall.length) {
        this.shopList.innerHTML = '<p class="awd__empty">Duvara henüz ürün eklenmedi.</p>';
        return;
      }
      this.shopList.innerHTML = this.wall
        .map(
          (item) => `
          <div class="awd__shop-row">
            <div class="awd__shop-cell awd__shop-cell--title">
              <strong>${escapeHtml(item.product.title)}</strong>
            </div>
            <div class="awd__shop-cell">${escapeHtml(item.selected.size)} cm</div>
            <div class="awd__shop-cell">${escapeHtml(item.selected.frame)}</div>
            <div class="awd__shop-cell">${money(item.price, this)}</div>
            <div class="awd__shop-cell awd__shop-cell--actions">
              <button type="button" data-shop-edit="${item.uid}" title="Düzenle" aria-label="Düzenle">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
              </button>
              <button type="button" data-shop-del="${item.uid}" title="Kaldır" aria-label="Kaldır">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>
              </button>
            </div>
          </div>`
        )
        .join('');
      this.shopList.querySelectorAll('[data-shop-edit]').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.shopDrawer?.setAttribute('hidden', '');
          this.selectPoster(btn.dataset.shopEdit);
          this.openConfigure(btn.dataset.shopEdit);
        });
      });
      this.shopList.querySelectorAll('[data-shop-del]').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.removePoster(btn.dataset.shopDel);
          this.renderShopList();
          if (!this.wall.length) this.shopDrawer?.setAttribute('hidden', '');
        });
      });
    }

    updateTotals() {
      const total = this.wall.reduce((sum, item) => sum + Number(item.price || 0), 0);
      if (this.subtotalEl) this.subtotalEl.textContent = money(total, this);
      if (this.shopBtn) {
        this.shopBtn.disabled = this.wall.length === 0;
        this.shopBtn.textContent = this.wall.length
          ? `Duvarı sepete ekle (${this.wall.length})`
          : 'Duvarı sepete ekle';
      }
      this.renderShopList();
    }

    /* ---------- cart sync (duvara ekle = sepete ekle) ---------- */

    desiredCartCounts() {
      const counts = {};
      this.wall.forEach((item) => {
        if (!item.variantId) return;
        counts[item.variantId] = (counts[item.variantId] || 0) + 1;
      });
      return counts;
    }

    updateCartCount(n) {
      const bag = this.querySelector('.awd__bag');
      const bubble = this.querySelector('[data-awd-cart-count]');
      if (!bubble) return;
      const count = Number(n || 0);
      if (bag) bag.classList.toggle('awd__bag--empty', count < 1);
      bubble.classList.toggle('awd__cart-bubble--long', count >= 100);
      if (count < 1) {
        bubble.innerHTML = '';
        return;
      }
      bubble.innerHTML = `<span aria-hidden="true">${count}</span>`;
    }

    async syncCart() {
      const desired = this.desiredCartCounts();
      const prev = this._cartSynced || {};
      const updates = {};
      new Set([...Object.keys(desired), ...Object.keys(prev)]).forEach((vid) => {
        const want = desired[vid] || 0;
        if (want !== (prev[vid] || 0)) updates[vid] = want;
      });
      if (!Object.keys(updates).length) return;
      /* Aynı anda tek senkron: art arda tıklamalarda sıraya al */
      this._cartQueue = (this._cartQueue || Promise.resolve()).then(async () => {
        try {
          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ updates }),
          });
          if (!res.ok) throw new Error('cart update failed');
          const cart = await res.json();
          this._cartSynced = { ...prev, ...updates };
          Object.keys(this._cartSynced).forEach((k) => {
            if (!this._cartSynced[k]) delete this._cartSynced[k];
          });
          this.updateCartCount(cart.item_count);
        } catch (err) {
          console.error(err);
        }
      });
      return this._cartQueue;
    }

    async addWallToCart() {
      if (!this.wall.length) return;
      const btn = this.querySelector('[data-awd-shop-add]');
      if (btn) btn.disabled = true;
      try {
        await this.syncCart();
        window.location.href = '/cart';
      } catch (err) {
        console.error(err);
        window.alert('Sepete eklenirken bir sorun oluştu.');
        if (btn) btn.disabled = false;
      }
    }

    /* ---------- share ---------- */

    bindShare() {
      this.shareEl = this.querySelector('[data-awd-share]');
      this.sharePreview = this.querySelector('[data-awd-share-preview]');
      this.querySelector('[data-awd-share-open]')?.addEventListener('click', () => this.openShare());
      this.querySelectorAll('[data-awd-share-close]').forEach((el) =>
        el.addEventListener('click', () => this.shareEl?.setAttribute('hidden', ''))
      );
      this.querySelector('[data-awd-share-copy]')?.addEventListener('click', async () => {
        const url = this.buildShareUrl();
        try {
          await navigator.clipboard.writeText(url);
        } catch (e) {
          const tmp = document.createElement('textarea');
          tmp.value = url;
          document.body.appendChild(tmp);
          tmp.select();
          document.execCommand('copy');
          tmp.remove();
        }
        const badge = this.querySelector('[data-awd-share-copied]');
        if (badge) {
          badge.hidden = false;
          clearTimeout(this._copiedTimer);
          this._copiedTimer = setTimeout(() => {
            badge.hidden = true;
          }, 2200);
        }
      });
      this.querySelector('[data-awd-share-download]')?.addEventListener('click', () => {
        if (!this._shareCanvas) return;
        try {
          const a = document.createElement('a');
          a.download = 'alalart-duvarim.png';
          a.href = this._shareCanvas.toDataURL('image/png');
          a.click();
        } catch (e) {
          window.alert('Görsel indirilemedi.');
        }
      });
    }

    buildShareUrl() {
      const state = {
        b: [...this.querySelectorAll('[data-awd-bg-item]')].findIndex((el) =>
          el.classList.contains('is-active')
        ),
        i: this.wall.map((item) => ({
          h: item.product.handle,
          s: item.selected.size,
          f: item.selected.frame,
          p: item.selected.placement,
          x: Math.round(item.x * 10) / 10,
          y: Math.round(item.y * 10) / 10,
        })),
      };
      return `${window.location.origin}${window.location.pathname}?awdw=${encodeState(state)}`;
    }

    async openShare() {
      if (!this.shareEl) return;
      this.shareEl.removeAttribute('hidden');
      const mail = this.querySelector('[data-awd-share-mail]');
      const wa = this.querySelector('[data-awd-share-wa]');
      const url = this.buildShareUrl();
      if (mail) {
        mail.href = `mailto:?subject=${encodeURIComponent('Alalart duvar tasarımım')}&body=${encodeURIComponent(
          `Duvar tasarımıma göz at: ${url}`
        )}`;
      }
      if (wa) wa.href = `https://wa.me/?text=${encodeURIComponent(`Alalart duvar tasarımım: ${url}`)}`;
      if (this.sharePreview) {
        this.sharePreview.innerHTML = '<p class="awd__empty">Önizleme hazırlanıyor…</p>';
        try {
          const canvas = await this.buildSnapshot();
          this._shareCanvas = canvas;
          this.sharePreview.innerHTML = '';
          canvas.className = 'awd__share-canvas';
          this.sharePreview.appendChild(canvas);
        } catch (e) {
          console.error(e);
          this.sharePreview.innerHTML = '<p class="awd__empty">Önizleme oluşturulamadı.</p>';
        }
      }
    }

    async buildSnapshot() {
      const canvasArea = this.querySelector('.awd__canvas');
      const areaRect = canvasArea.getBoundingClientRect();
      const W = 1400;
      const H = Math.max(200, Math.round((W * areaRect.height) / areaRect.width));
      const cv = document.createElement('canvas');
      cv.width = W;
      cv.height = H;
      const ctx = cv.getContext('2d');
      const k = W / areaRect.width;

      /* arka plan (cover) */
      ctx.fillStyle = '#eceae6';
      ctx.fillRect(0, 0, W, H);
      const bgEl = this.querySelector('.awd__bg.is-active .awd__bg-img');
      const bg = await loadImage(bgEl?.currentSrc || bgEl?.src || null);
      if (bg) {
        const scale = Math.max(W / bg.naturalWidth, H / bg.naturalHeight);
        const dw = bg.naturalWidth * scale;
        const dh = bg.naturalHeight * scale;
        ctx.drawImage(bg, (W - dw) / 2, (H - dh) / 2, dw, dh);
      }

      /* posterler (z sırasına göre) */
      const items = [...this.wall].sort((a, b) => a.z - b.z);
      for (const item of items) {
        const el = this.stage.querySelector(`[data-uid="${item.uid}"]`);
        if (!el) continue;
        const r = el.getBoundingClientRect();
        const x = (r.left - areaRect.left) * k;
        const y = (r.top - areaRect.top) * k;
        const w = r.width * k;
        const h = r.height * k;

        const art = await loadImage(item.image);

        ctx.save();
        ctx.shadowColor = 'rgba(0,0,0,0.28)';
        ctx.shadowBlur = 16 * k;
        ctx.shadowOffsetY = 7 * k;
        ctx.fillStyle = item._synthMat
          ? (window.AlaPaspas.kagitRenk || '#f4f1ea')
          : '#f4f4f4';
        ctx.fillRect(x, y, w, h);
        ctx.restore();

        if (art) {
          ctx.save();
          ctx.beginPath();
          ctx.rect(x, y, w, h);
          ctx.clip();
          const imgRatio = art.naturalWidth / art.naturalHeight;
          let dw;
          let dh;
          if (item._synthMat) {
            /*
              Ortala: eser, paspas kuralının verdiği kutuya sığar. Ekrandaki
              çizimle aynı işlev çağrıldığı için tuval ile ekran birbirinden
              ayrışamaz.
            */
            const kutu = matEserKutusu(w, h);
            const t = item._matTuck || 1;
            const oran = Math.min((kutu.g * t) / art.naturalWidth, (kutu.y * t) / art.naturalHeight);
            dw = art.naturalWidth * oran;
            dh = art.naturalHeight * oran;
          } else {
            /* Tam Oturt: DOM'daki gibi contain + fill ölçeği */
            const boxRatio = w / h;
            if (imgRatio > boxRatio) {
              dw = w;
              dh = w / imgRatio;
            } else {
              dh = h;
              dw = h * imgRatio;
            }
            const s = item._fillScale || 1;
            dw *= s;
            dh *= s;
          }
          ctx.drawImage(art, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
          ctx.restore();
        }

        if (item._overlayFrame) {
          const stageRect = this.stage.getBoundingClientRect();
          const pxPerCm = stageRect.width / this.wallWidthCm;
          const lip = TPC_FRAME_LIP_CM * pxPerCm * k;
          ctx.fillStyle = FRAME_COLORS[item.selected.frame] || '#1a1a1a';
          ctx.fillRect(x, y, w, lip);
          ctx.fillRect(x, y + h - lip, w, lip);
          ctx.fillRect(x, y, lip, h);
          ctx.fillRect(x + w - lip, y, lip, h);
        }
      }
      return cv;
    }

    async restoreFromUrl() {
      const raw = new URLSearchParams(window.location.search).get('awdw');
      if (!raw) return;
      const state = decodeState(raw);
      if (!state || !Array.isArray(state.i)) return;
      const bgs = this.querySelectorAll('[data-awd-bg-item]');
      if (state.b >= 0 && bgs[state.b]) {
        bgs.forEach((el) => el.classList.remove('is-active'));
        bgs[state.b].classList.add('is-active');
      }
      for (const it of state.i) {
        const product = await this.getProduct(it.h);
        if (!product) continue;
        await this.addProduct(product, {
          selected: { size: it.s, frame: it.f, placement: it.p },
          x: it.x,
          y: it.y,
          silent: true,
        });
      }
    }

    /* ---------- drag ---------- */

    onPosterPointerDown(e, uid) {
      if (e.button != null && e.button !== 0) return;
      if (e.target.closest('.awd__poster-controls')) return;
      const item = this.wall.find((i) => i.uid === uid);
      if (!item) return;
      this.selectPoster(uid);
      const el = this.stage.querySelector(`[data-uid="${uid}"]`);
      el?.classList.add('is-dragging');
      el?.setPointerCapture?.(e.pointerId);
      const stageRect = this.stage.getBoundingClientRect();
      this.drag = {
        uid,
        pointerId: e.pointerId,
        offsetX: e.clientX - (stageRect.left + (item.x / 100) * stageRect.width),
        offsetY: e.clientY - (stageRect.top + (item.y / 100) * stageRect.height),
      };
      e.preventDefault();
    }

    bindStagePointer() {
      const move = (e) => {
        if (!this.drag) return;
        const item = this.wall.find((i) => i.uid === this.drag.uid);
        if (!item) return;
        const stageRect = this.stage.getBoundingClientRect();
        const x = ((e.clientX - this.drag.offsetX - stageRect.left) / stageRect.width) * 100;
        const y = ((e.clientY - this.drag.offsetY - stageRect.top) / stageRect.height) * 100;
        item.x = Math.min(95, Math.max(5, x));
        item.y = Math.min(95, Math.max(5, y));
        this.renderPoster(item);
      };
      const up = (e) => {
        if (!this.drag) return;
        const el = this.stage.querySelector(`[data-uid="${this.drag.uid}"]`);
        el?.classList.remove('is-dragging');
        try {
          el?.releasePointerCapture?.(this.drag.pointerId);
        } catch (_) {}
        this.drag = null;
      };
      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', up);
      window.addEventListener('pointercancel', up);
      window.addEventListener('resize', () => {
        this.wall.forEach((item) => this.renderPoster(item));
      });
    }
  }

  if (!customElements.get('art-wall-designer')) {
    customElements.define('art-wall-designer', ArtWallDesigner);
  }
})();
